module.exports = __webpack_public_path__ + "img/contours.b289480.png";